import { render, staticRenderFns } from "./SocialPostEditor.vue?vue&type=template&id=486825e7&scoped=true&"
import script from "./SocialPostEditor.vue?vue&type=script&lang=js&"
export * from "./SocialPostEditor.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostEditor.vue?vue&type=style&index=0&id=486825e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486825e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486825e7')) {
      api.createRecord('486825e7', component.options)
    } else {
      api.reload('486825e7', component.options)
    }
    module.hot.accept("./SocialPostEditor.vue?vue&type=template&id=486825e7&scoped=true&", function () {
      api.rerender('486825e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostEditor.vue"
export default component.exports